// extracted by mini-css-extract-plugin
export default {"label":"page_label__C7x87","description":"page_description__M7b5N"};